import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3001/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
});

// Add token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('accessToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export interface UserPreferences {
  id: string;
  userId: string;

  // Notification Settings
  emailNotifications: boolean;
  pushNotifications: boolean;
  dailyReportTime: string;
  timezone: string;

  // Display Settings
  theme: string;
  language: string;

  // Privacy Settings
  dataSharing: boolean;
  analyticsEnabled: boolean;

  createdAt: string;
  updatedAt: string;
}

export interface UpdatePreferencesData {
  // Notification Settings
  emailNotifications?: boolean;
  pushNotifications?: boolean;
  dailyReportTime?: string;
  timezone?: string;

  // Display Settings
  theme?: string;
  language?: string;

  // Privacy Settings
  dataSharing?: boolean;
  analyticsEnabled?: boolean;
}

/**
 * Get user preferences
 */
export const getUserPreferences = async (): Promise<UserPreferences> => {
  const response = await api.get('/preferences');
  return response.data.data;
};

/**
 * Update user preferences
 */
export const updateUserPreferences = async (data: UpdatePreferencesData): Promise<UserPreferences> => {
  const response = await api.put('/preferences', data);
  return response.data.data;
};

/**
 * Reset preferences to default
 */
export const resetUserPreferences = async (): Promise<UserPreferences> => {
  const response = await api.post('/preferences/reset');
  return response.data.data;
};
